import React from "react";
import styled from "styled-components";

const Social = () => {
	return (
		<StyledSocial>
			<div>
				<span className="social-text">Socials</span>

				<a
					href="https://twitter.com/Iamoshai"
					target="_blank"
					rel="noreferrer"
				>
					<img src="./images/Twitter.svg" alt="" />
				</a>
				<a
					href="https://www.instagram.com/ek.oshai/"
					target="_blank"
					rel="noreferrer"
				>
					<img src="./images/Instagram.svg" alt="" />
				</a>
				<a
					href="https://www.linkedin.com/in/ekene-oshai-a41206161/"
					target="_blank"
					rel="noreferrer"
				>
					<img src="./images/LinkedIn.svg" alt="" />
				</a>
			</div>
		</StyledSocial>
	);
};

export default Social;

const StyledSocial = styled.section`
	padding: 32px 0;
	margin: 0 10%;
	margin-top: 72px;
	border-top: 1px solid rgba(0, 0, 0, 0.3);
	border-bottom: 1px solid rgba(0, 0, 0, 0.3);
	a {
		align-self: center;
	}

	img {
		max-width: 30px;
		width: 40px;
	}

	& > div {
		display: flex;

		gap: 16px;
		justify-content: space-between;

		max-width: 500px;
		margin: 0 auto;
		align-items: center;
		.social-text {
			font-size: 2.5rem;
			font-weight: 700;
			color: rgba(220, 220, 220, 1);
		}

		img {
			width: 80px;
		}
	}

	@media (min-width: 750px) {
		padding: 64px 16px;

		& > div {
			justify-content: space-between;

			img {
				width: 40px;
			}
		}
		.social-text {
			font-size: 2rem;
		}

		margin: 0 15%;
	}
`;
